import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { ProductImage, BagIcon, Tags } from '@cps'
import { cartMobx } from 'restaurant'
import CartPackPicker from '../CartPackPicker'
import { TimePickBar } from '@pages/checkout/component'
import './index.scss'

export interface ICartExtChangeProps {
  cnt?: number;
  show: boolean;
  disableChange?: boolean;
  swapBuyProducts?: IViewCartItem[] | IViewOrderDetail[];
  onSelect?: () => void;
  onRemove?: (parentPk: string, subPk: string) => void;
}

const CartExtChange: React.FC<ICartExtChangeProps> = (props) => {
  const { cnt, show, disableChange, swapBuyProducts, onSelect, onRemove } = props

  const filterProducts = useMemo(() => {
    return (swapBuyProducts as IViewCartItem[])?.filter(
      (cartItem) => !!cartItem && cartItem.name
    )
  }, [swapBuyProducts])

  if (!filterProducts?.length && !show) {
    return null
  }

  const handleSelectProducts = () => {
    if (!cnt || disableChange) {
      return
    }
    onSelect && onSelect()
  }

  const handleRemove = (parentPk: string, subPk: string) => {
    onRemove && onRemove(parentPk, subPk)
  }

  const handleChangePackCnt = (cartItem, cnt: number) => {
    cartMobx.setCarPackFkeys(`${cartItem.fkey}_swapBuy_${cartItem.pk}`, cnt)
  }

  return (
    <div
      className={`cart-exchange-wrapper${
        swapBuyProducts?.length ? ' has-products' : ''
      }${
        cartMobx.needPack ? ' has-need-pack' : ''
      }`}
      // style={{ height: swapBuyProducts?.length * 70 }}
    >
      {!cartMobx.needPack && !!cnt && !disableChange && (
        <div className='cart-exchange-header'>
          {/* <div className='exchange-tips'>
            <span className='exchange-tag'>{i18n.t('newCart.exchange')}</span>
            <span>{i18n.t('newCart.exchangeTip')}</span>
          </div>
          <span>
            {i18n.t('newCart.chances', { cnt })}{' '}
            <i className='iconfont icon-chevron-right'></i>
          </span> */}
          <div className='exchange-header-tips' data-cypid='cartExchangeSelectProduct' onClick={handleSelectProducts}>{i18n.t('newCart.chances2', { cnt })} <i className='iconfont icon-chevron-right'></i></div>
        </div>
      )}
      <div className='cart-exchange-products'>
        {filterProducts?.map((cartItem, index: number) => (
          <div
            className={classNames('cart-product-item', {
              'disable-cart-items': cartItem.disabled,
              'disable-togo': cartMobx.needPack && !cartItem.isCanTogo
            })}
            key={cartItem.pk}
          >
            {!cartMobx.needPack && (
              <div className='remove-item'>
                <i
                  className='iconfont icon-huabanbeifen32x'
                  data-cypid={`cartExchangeRemove_parentPk_${cartItem?.parentPk}_pk_${cartItem?.pk}`}
                  onClick={() => handleRemove(cartItem.parentPk, cartItem.pk)}
                >
                </i>
              </div>
            )}
            <div className='product-info'>
              <div className='item-detail'>
                <ProductImage width={40} imgSrc={cartItem.pic} />
                <div className='product-name'>
                  <strong>{!cartMobx.needPack && !!cartItem.isTogo && <BagIcon size='small' />}{cartItem.name}</strong>
                  <small className='grey'>{cartItem.optionStr}</small>
                  <div className='product-extra-info'>
                    <Tags datas={[...(cartItem.tags || []), ...(cartItem.allergys || [])]} disableSingleSale={!cartItem.isSingleSale} />
                  </div>
                  {!!cartMobx.needPack && !cartItem.isCanTogo && <span className='disable-togo'>{i18n.t('newCart.productCanNotTogo')}</span>}
                  {cartItem.startTime && <TimePickBar type='product' scene='swapBuy' cartItem={cartItem} />}
                </div>
                <div className='product-price'>
                  <span dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(cartItem.actualPrice) }}></span>
                  {cartItem.actualPrice !== cartItem.totalPrice && (
                    <del dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(cartItem.totalPrice) }}></del>
                  )}
                </div>
              </div>
              {cartItem.disabled && (<div className='item-disabled'>{i18n.t(`checkout.disabledReason.${(cartItem.disabledReason === 'SINGLESWAPBUYINEFFECTIVE' ? 'SINGLESWAPBUYINEFFECTIVE' : 'soldout').toLocaleLowerCase()}`)}</div>)}
              {cartMobx.needPack && cartItem.isCanTogo && (
                <CartPackPicker cnt={cartMobx.cartPackFkeys[`${cartItem.fkey}_swapBuy_${cartItem.pk}`] || 0} total={cartItem.cnt} onChange={cnt => handleChangePackCnt(cartItem, cnt)} />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default observer(CartExtChange)
